import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import {
  UserService,
  SocketService,
  RouteEventsService,
} from "../../../../services";

@Component({
  selector: "social-auth-button",
  templateUrl: "./social-auth-button.component.html",
  styleUrls: [
    "./social-auth-button.component.scss",
    "../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class SocialAuthButtonComponent {
  public isSubmitting: boolean = false;

  @Input() provider: string;
  @Input() useCase: string;

  constructor(
    private router: Router,
    private userService: UserService,
    private socketService: SocketService,
    private routeEventsService: RouteEventsService
  ) {}

  public attemptSocialAuth() {
    switch (this.provider) {
      case "Facebook":
        this.attemptFacebookAuth();
        break;
      case "Twitter":
        this.attemptTwitterAuth();
        break;
      case "Google":
        this.attemptGoogleAuth();
        break;
    }
  }

  public attemptTwitterAuth() {
    this.isSubmitting = true;
    this.socketService.connect();
    this.userService.attemptTwitterAuth();
  }

  public attemptGoogleAuth() {
    this.isSubmitting = true;
    this.socketService.connect();
    this.userService.attemptGoogleAuth();
  }

  public attemptFacebookAuth() {
    this.isSubmitting = true;

    this.userService.attemptFacebookAuth().then(
      (data) => this.onSkipHandler(),
      (err) => {
        this.isSubmitting = false;
      }
    );
  }

  /* navigate the user to where they came from */
  public onSkipHandler() {
    this.router.navigate([this.routeEventsService.previousRoutePath.value]);
  }
}
